module.exports = __webpack_public_path__ + "static/png_stat_sitePerso-7c38a89d7f659efbeb7c61eb1aad0cbd.png";